'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css2 = require('antd/lib/modal/style/css');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _css3 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css4 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css5 = require('antd/lib/icon/style/css');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _css6 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSortableHoc = require('react-sortable-hoc');

var _media = require('../containers/media');

var _media2 = _interopRequireDefault(_media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = _select2.default.Option;

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var value = _ref.value,
      imageSize = _ref.imageSize,
      onDelete = _ref.onDelete,
      type = _ref.type,
      onTypeChange = _ref.onTypeChange,
      onInputChange = _ref.onInputChange,
      productTypes = _ref.productTypes;

  if (type === 'bannerCreate') {
    return _react2.default.createElement(
      'li',
      { id: value.banner_id, className: 'sortable-element' },
      _react2.default.createElement('img', { src: value.image + '!' + imageSize, alt: value.banner_id }),
      _react2.default.createElement(
        _button2.default,
        { onClick: function onClick(e) {
            return onDelete(value.banner_id);
          } },
        _react2.default.createElement(_icon2.default, { type: 'delete' })
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginLeft: '40px' } },
        '\u7C7B\u578B\uFF1A',
        _react2.default.createElement(
          _select2.default,
          { value: value.type ? value.type : 'all', style: { width: '300px', display: 'block' },
            disabled: value.edit ? false : true, onChange: function onChange(e) {
              return onTypeChange(e, value.banner_id);
            } },
          _react2.default.createElement(
            Option,
            { value: 'all', disabled: true },
            '\u8BF7\u9009\u62E9\u56FE\u7247\u7C7B\u578B'
          ),
          _react2.default.createElement(
            Option,
            { value: 'campaign' },
            'campaign'
          ),
          _react2.default.createElement(
            Option,
            { value: 'product_detail' },
            'product_detail'
          ),
          _react2.default.createElement(
            Option,
            { value: 'product_list' },
            'product_list'
          )
        ),
        '\u6307\u5411\uFF1A',
        value.type === 'product_list' && !value.target ? productTypes && productTypes.map(function (type) {
          return '(' + type.name + ' : ' + type.product_type_id + ' \uFF09  ';
        }) : null,
        _react2.default.createElement(_input2.default, { id: 'target', style: { width: '300px', display: 'block' }, value: value.target,
          disabled: value.edit ? false : true,
          placeholder: value.type === 'campaign' ? '请输入网页地址' : value.type === 'product_detail' ? '请输入商品编号' : value.type === 'product_list' ? '请输入商品类别对应的id' : null,
          onChange: function onChange(e) {
            return onInputChange(e, value.banner_id, 'target');
          } }),
        '\u6392\u5E8F\u503C\uFF1A',
        _react2.default.createElement(_input2.default, { id: 'sort', style: { width: '300px', display: 'block' }, value: value.default_order,
          disabled: value.edit ? false : true,
          onChange: function onChange(e) {
            return onInputChange(e, value.banner_id, 'default_order');
          } })
      )
    );
  } else {
    return _react2.default.createElement(
      'li',
      { className: 'sortable-element' },
      _react2.default.createElement('img', { src: value.url + '!' + imageSize, alt: value.id }),
      _react2.default.createElement(
        _button2.default,
        { onClick: onDelete.bind(value.id) },
        _react2.default.createElement(_icon2.default, { type: 'delete', onClick: onDelete.bind(value.id) })
      )
    );
  }
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var items = _ref2.items,
      onDelete = _ref2.onDelete,
      imageSize = _ref2.imageSize,
      type = _ref2.type,
      onTypeChange = _ref2.onTypeChange,
      onInputChange = _ref2.onInputChange,
      productTypes = _ref2.productTypes;

  return _react2.default.createElement(
    'ul',
    null,
    items.map(function (value, index) {
      return _react2.default.createElement(SortableItem, { imageSize: imageSize, key: 'item-' + index, index: index, value: value, onDelete: onDelete,
        type: type, onTypeChange: onTypeChange, onInputChange: onInputChange, productTypes: productTypes });
    })
  );
});

var ProductDescEditor = function (_React$Component) {
  _inherits(ProductDescEditor, _React$Component);

  function ProductDescEditor(props) {
    _classCallCheck(this, ProductDescEditor);

    var _this = _possibleConstructorReturn(this, (ProductDescEditor.__proto__ || Object.getPrototypeOf(ProductDescEditor)).call(this, props));

    var value = _this.props.value || [];
    _this.state = {
      visible: false,
      selectedMedia: value
    };
    _this.showModal = _this.showModal.bind(_this);
    _this.handleOk = _this.handleOk.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleSortEnd = _this.handleSortEnd.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.onTypeChange = _this.onTypeChange.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    return _this;
  }

  _createClass(ProductDescEditor, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        selectedMedia: nextProps.value || []
      });
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      this.setState({
        visible: true
      });
    }
  }, {
    key: 'handleOk',
    value: function handleOk(e) {

      this.setState({
        visible: false
      });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel(e) {

      this.setState({
        visible: false
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(id) {
      var that = this;
      var selectedMedia = this.state.selectedMedia.concat();
      if (this.props.type === 'bannerCreate') {
        _modal2.default.confirm({
          title: '确认删除?',
          onOk: function onOk() {
            var index = selectedMedia.findIndex(function (ele) {
              return ele.banner_id == id;
            });
            if (selectedMedia[index] && selectedMedia[index].edit) {
              selectedMedia.splice(index, 1);
              that.setState({
                selectedMedia: Array.from(selectedMedia)
              });
              that.triggerChange(selectedMedia);
              that.props.onShowSubmit(false);
            } else {
              that.props.handleDelete(id);
            }
            return;
          },
          onCancel: function onCancel() {
            return;
          }
        });
      } else {
        var index = selectedMedia.findIndex(function (ele) {
          return ele.id == id;
        });
        selectedMedia.splice(index, 1);
        this.setState({
          selectedMedia: Array.from(selectedMedia)
        });
        this.triggerChange(selectedMedia);
      }
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(_ref3) {
      var id = _ref3.id,
          url = _ref3.url;

      var selectedMedia = void 0;
      if (this.props.type === 'bannerCreate') {
        selectedMedia = this.state.selectedMedia.concat();
        var newMedia = selectedMedia.filter(function (item) {
          return item.edit === true;
        });
        if (newMedia.length > 0) {
          _message2.default.error('保存后才能继续添加');
          return;
        }
        selectedMedia.push({
          banner_id: id, image: url, edit: true
        });
        this.setState({
          selectedMedia: Array.from(selectedMedia),
          visible: false
        });
        this.props.onShowSubmit(true);
      } else {
        if (this.props.single) {
          selectedMedia = [{ id: id, url: url }];
        } else {
          selectedMedia = this.state.selectedMedia;
          var index = selectedMedia.findIndex(function (ele) {
            return ele.id == id;
          });
          if (index !== -1) {
            // 找到对应 ID，说明是取消已选择图片
            selectedMedia.splice(index, 1); // 删除目标图片
          } else {
            // 未找到对应 ID，说明是选择了一个新图片
            selectedMedia.push({
              id: id, url: url
            }); // 加入新图片
          }
        }
        this.setState({
          selectedMedia: Array.from(selectedMedia)
        });
      }

      this.triggerChange(selectedMedia);
    }
  }, {
    key: 'handleSortEnd',
    value: function handleSortEnd(_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;

      this.setState({
        selectedMedia: (0, _reactSortableHoc.arrayMove)(this.state.selectedMedia, oldIndex, newIndex)
      });
    }
  }, {
    key: 'triggerChange',
    value: function triggerChange(selectedMedia) {
      // Should provide an event to pass value to Form.
      var onChange = this.props.onChange;
      if (onChange) {
        onChange(selectedMedia);
      }
    }
  }, {
    key: 'onTypeChange',
    value: function onTypeChange(value, imageId) {
      if (this.props.type === 'bannerCreate') {
        var selectedMedia = this.state.selectedMedia.concat();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = selectedMedia[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var media = _step.value;

            if (media.banner_id === imageId) {
              media.type = value;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.setState({
          selectedMedia: selectedMedia
        });
      }
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(e, imageId, name) {
      if (this.props.type === 'bannerCreate') {
        var selectedMedia = this.state.selectedMedia.concat();
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = selectedMedia[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var media = _step2.value;

            if (media.banner_id === imageId) media[name] = e.target.value;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.setState({
          selectedMedia: selectedMedia
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _button2.default,
          { type: 'primary', onClick: this.showModal },
          '\u6DFB\u52A0\u56FE\u7247'
        ),
        _react2.default.createElement(
          _modal2.default,
          { title: '\u5A92\u4F53\u5E93', width: '80%', visible: this.state.visible,
            onOk: this.handleOk, onCancel: this.handleCancel,
            footer: [_react2.default.createElement(
              _button2.default,
              { type: 'primary', size: 'large', loading: this.state.loading, onClick: this.handleOk },
              '\u786E\u5B9A'
            )]
          },
          _react2.default.createElement(_media2.default, { selectable: true, onSelect: this.handleSelect, selectedMedia: this.state.selectedMedia })
        ),
        _react2.default.createElement(SortableList, { items: this.state.selectedMedia, onDelete: this.handleDelete, onSortEnd: this.handleSortEnd, imageSize: this.props.imageSize,
          type: this.props.type, onTypeChange: this.onTypeChange, onInputChange: this.onInputChange, productTypes: this.props.productTypes })
      );
    }
  }]);

  return ProductDescEditor;
}(_react2.default.Component);

exports.default = ProductDescEditor;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_desc_editor.js
// module id = 1378
// module chunks = 0